<template>
    <v-container class="py-12">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">Equipamentos</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
                            {
                                text: 'Homepage',
                                disabled: false,
                                to: '/home',
                                exact: true,
                            },
                            {
                                text: 'Equipamentos',
                                disabled: true,
                                exact: true,
                            },
                        ]"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn type="button" color="primary" elevation="0" to="/equipamentos/novo">Incluir</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card class="filter-card">
                    <v-card-title class="filter-card-title">Filtro</v-card-title>
                    <v-card-text>
                        <v-form @submit.prevent="load()">
                            <v-row>
                                <v-col>
                                    <v-text-field dense id="name" label="Nome" v-model="datalist.filter.name" hide-details
                                        outlined></v-text-field>
                                </v-col>
                                <v-col>
                                    <v-text-field dense id="email" label="Identificador" v-model="datalist.filter.uuid"
                                        hide-details outlined></v-text-field>
                                </v-col>
                                <v-col>
                                    <v-select dense :items="dataset.equipmentStatus" label="Comunicação"
                                        v-model="datalist.filter.operational_status" item-value="value" item-text="name" outlined
                                        hide-details="auto">
                                    </v-select>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-btn id="btnFilter" type="submit" color="primary" dark elevation="2">Filtrar</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-data-table :headers="datalist.headers" :items="dataset.data" :server-items-length="datalist.count"
                    :disable-sort="true" :loading="dataset.loading" no-data-text="Nenhum equipamento foi encontrado"
                    loading-text="Carregando dados..." class="app-table hover-table" hide-default-footer>

                    <template v-slot:[`item.type`]="{ item }">
                        {{ item.type | enum(dataset.equipmentTypes, "id", "name") }}
                    </template>

                    <template v-slot:[`item.action_type`]="{ item }">
                        {{ item.action_type | enum(dataset.actionTypes, "id", "name") }}
                    </template>

                    <template v-slot:[`item.operational_status`]="{ item }">
                        <v-chip small label :color="operationalStatusColor(item.operational_status)" :text-color="item.operational_status === 'online' ? 'white' : undefined">
                            {{ operationalStatusLabel(item.operational_status) }}
                        </v-chip>
                    </template>

                    <template v-slot:[`item.last_updated`]="{ item }">
                        <span v-if="item.last_updated">
                            {{ item.last_updated | defaultDate('DD/MM/YYYY HH:mm:ss') }}
                        </span>
                        <span v-else>
                            N/A
                        </span>
                    </template>

                    <template v-slot:[`item.face_capacity`]="{ item }">
                        <div class="face-capacity-cell">
                            <div class="face-capacity-line">
                                <strong>{{ item.face_count || 0 }}</strong>
                                <span>/ {{ item.face_capacity_limit || 3000 }}</span>
                            </div>
                            <v-progress-linear
                                :value="Number(item.face_capacity_percent || 0)"
                                height="5"
                                rounded
                                :color="faceCapacityColor(item.face_capacity_status)"
                            ></v-progress-linear>
                            <small :class="`face-capacity-${item.face_capacity_status || 'normal'}`">
                                {{ faceCapacityLabel(item.face_capacity_status) }}
                            </small>
                        </div>
                    </template>

                    <template v-slot:[`item.created_at`]="{ item }">
                        {{ item.created_at | defaultDate }}
                    </template>

                    <template v-slot:[`item.actions`]="{ item }">
                        <v-row align="center">
                            <v-icon @click="viewItem(item)" size="large">
                                mdi-pencil-outline
                            </v-icon>
                        </v-row>
                    </template>
                </v-data-table>
                <v-divider></v-divider>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

import Vue from "vue";
import VueLodash from 'vue-lodash'
import _ from 'lodash';
import axios from 'axios';

import object from "@/common/util/object"

import actionTypes from "@/common/data/action-types.data"
import equipmentTypes from "@/common/data/equipment-types.data"

Vue.use(VueLodash, { lodash: _ })

export default {
    name: "EquipmentList",

    data: () => ({
        dataset: {
            data: [],
            equipmentTypes: equipmentTypes,
            actionTypes: actionTypes,
            equipmentStatus: [
                { value: null, name: "Todos" },
                { value: "online", name: "Online" },
                { value: "offline", name: "Sem comunicação" },
                { value: "inactive", name: "Inativo" },
            ],
            loading: false
        },
        datalist: {
            filter: {
                name: "",
                email: "",
                operational_status: null
            },
            headers: [
                { text: "Nome", value: "name" },
                { text: "Identificador", value: "uuid" },
                { text: "Tipo", value: "type" },
                { text: "Ação", value: "action_type" },
                { text: "Endereço IP", value: "ip" },
                { text: "Comunicação", value: "operational_status" },
                { text: "Última comunicação", value: "last_updated" },
                { text: "Faces", value: "face_capacity" },
                { text: "Criado em", value: "created_at" },
                { text: 'Ações', value: 'actions', sortable: false },
            ],
            count: 0,
            options: {
                page: 1,
                size: 10,
                sortBy: ['name'],
                sortDesc: [false],
            },
            footerOptions: {
                itemsPerPageText: 'Itens por página:',
                itemsPerPageOptions: [10, 20, 30, 40, 50],
                pageText: '{0}-{1} de {2}',
            }
        },
    }),

    created() {
        this.load();
    },

    methods: {
        operationalStatusLabel(status) {
            return {
                online: "Online",
                offline: "Sem comunicação",
                inactive: "Inativo",
            }[status] || "Sem comunicação";
        },

        operationalStatusColor(status) {
            return {
                online: "success",
                offline: "orange lighten-4",
                inactive: "grey lighten-3",
            }[status] || "orange lighten-4";
        },

        async load() {

            let search = Object.fromEntries(Object.entries(this.datalist.filter).filter(([_, v]) => v))

            search = !object.isEmpty(search) ? search : null;

            this.dataset.loading = true;

            var limit = this.datalist.options.size;

            try {
                const result = await axios.get('/api/v1/equipments', { params: { page: this.datalist.options.page, limit: limit, search: search } });

                this.dataset.data = result.data.content.data;
                this.datalist.count = result.data.content.paging.total;

            } catch (error) {
                console.log('error ', error)
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataset.loading = false;
            }

        },

        viewItem(item) {
            this.$router.push(`equipamentos/${item.id}`);
        },

        faceCapacityColor(status) {
            switch (status) {
                case 'full':
                    return 'error'
                case 'critical':
                    return 'error'
                case 'attention':
                    return 'warning'
                default:
                    return 'success'
            }
        },

        faceCapacityLabel(status) {
            switch (status) {
                case 'full':
                    return 'Limite atingido'
                case 'critical':
                    return 'Capacidade crítica'
                case 'attention':
                    return 'Atenção'
                default:
                    return 'Normal'
            }
        },

    },
};
</script>

<style lang="scss">
.face-capacity-cell {
    min-width: 120px;

    .face-capacity-line {
        display: flex;
        gap: 4px;
        align-items: baseline;
        margin-bottom: 4px;
    }

    small {
        display: block;
        margin-top: 3px;
        font-weight: 700;
    }

    .face-capacity-normal {
        color: #18A36F;
    }

    .face-capacity-attention {
        color: #B7791F;
    }

    .face-capacity-critical,
    .face-capacity-full {
        color: #C53030;
    }
}
</style>
